/**
 * Class to represent kindergarten.
 */
import { KindergartenContract } from '../../contracts/kindergarten.contract';
import { Organization } from '../organization/organization.model';
import { OrgType } from './org-type.model';

export class Kindergarten {
  constructor(
    public id: number,
    public uuid: string,
    public name: string,
    public lawId: string,
    public code: string,
    public note: string,
    public addressStreet?: string,
    public addressCity?: string,
    public addressDistrict?: string,
    public addressPostcode?: string,
    public addressCountry?: string,
    public productCodenames?: string[],
    public orgType?: OrgType[],
    public eEnrollmentState?: boolean,
    public isDemo?: boolean,
    public isPrimary?: boolean,
    public officialName?: string,
    public organization?: Organization
  ) {}

  /**
   * Deserialize JSON to typescript object.
   *
   * @param data
   */
  public static deserialize(data: KindergartenContract): Kindergarten {
    return new Kindergarten(
      data.id,
      data.uuid,
      data.name,
      data.law_id,
      data.code,
      data.note,
      data.address_street,
      data.address_city,
      data.address_district ?? null,
      data.address_postcode,
      data.address_country,
      data.product_codenames,
      data?.org_type?.map((orgType) => OrgType.deserialize(orgType)),
      data.e_enrollment_state,
      data.is_demo,
      data.is_primary,
      data.official_name,
      new Organization(data.organization?.official_name)
    );
  }

  /**
   * Serialize typescript object into basic javascript types.
   */
  public serialize(): KindergartenContract {
    return {
      id: this.id,
      uuid: this.uuid,
      name: this.name,
      law_id: this.lawId,
      code: this.code,
      note: this.note,
      address_street: this.addressStreet,
      address_city: this.addressCity,
      address_district: this.addressDistrict ?? undefined,
      address_postcode: this.addressPostcode,
      address_country: this.addressCountry,
      product_codenames: this.productCodenames,
      org_type: this.orgType?.map((orgType) => orgType.serialize()),
      e_enrollment_state: this.eEnrollmentState,
      is_demo: this.isDemo,
      is_primary: this.isPrimary,
      official_name: this.officialName,
      organization: this.organization.serialize(),
    };
  }
 
  public isCZ(): boolean {
    return this.addressCountry === 'CZ';
  }
  /** Check if its CZ kindergarten (MS) */
  public isCZKindergarten(): boolean {
    return this.isKindergarten() && this.isCZ();
  }

  /** Check if its CZ kindergarten (MS) */
  public isSKKindergarten(): boolean {
    return this.isKindergarten() && this.isSK();
  }

  /** Check if its CZ School (ZS) */
  public isCZSchool(): boolean {
    return this.isSchool() && this.isCZ();
  }

  /** Check if its school (MS) */
  public isSchool(): boolean {
    return this.orgType.some((type) => type.orgType === 'SCHOOL');
  }
  /** Check if its kindergarten (ZS) */
  public isKindergarten(): boolean {
    return this.orgType.some((type) => type.orgType === 'KINDERGARTEN');
  }


  public isSK(): boolean {
    return this.addressCountry === 'SK';
  }
}
